const urls = {
  get: {
    degrees: "/v1/pub/cursos_combo",
    hash: "/v1/pub/formaturas/hash",
    instituitions: "/v1/pub/instituicoes_combo",
    checkUserCPF: "/v1/pub/verificar_cpf_usuario/:cpf",
    continuation: "/v1/pub/formaturas/status_cadastro",
    companyData: "v1/empresas/identificadores/:id",
  },
  post: {
    field: "/v1/pub/formaturas/auto_adm",
  },
};

const applet = "/p";

const views = { suaformatura: `${applet}/cadastre-se`, parceiras: `${applet}/cadastre-se/:id` };

const ValidationStatus = {
  // campo validado pelo back-end, mas já está cadastrado no DB
  UNAVAILABLE: "UNAVAILABLE",
  // campo ainda não validado pelo back-end
  UNCHECKED: "UNCHECKED",
  // campo validado pelo back-end, mas com erro
  ERROR: "ERROR",
  // campo validado pelo back-end
  OK: "OK",
};

export { ValidationStatus, urls, applet, views };
